import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import HtmlContent from '@telialt/common-html-content/src/HtmlContent';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const VasBlockContainer = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('100')};
`;

export const TextWithIcon = styled.li`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    column-gap: ${getPurpurSpacing('150')};
    font-size: ${getPurpurTypography('scale75')};
`;

export const IconMd = styled(Icon)`
    flex-shrink: 0;
`;

export const RentVasSection = styled.section`
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};
    border-radius: ${getPurpurBorder('radiusMd')};
    background: ${getPurpurColor('backgroundPrimary')};
    margin-bottom: ${getPurpurSpacing('600')};
    padding: ${getPurpurSpacing('200')};

    ${purpurMedia('lg')`
        padding: ${getPurpurSpacing('300')};
    `}
`;
export const RentVasList = styled.ul`
    margin: ${getPurpurSpacing('300')} 0;
    padding: 0;
    display: grid;
    list-style: none;
    gap: ${getPurpurSpacing('300')};
    grid-auto-flow: row;

    ${purpurMedia('lg')`
        grid-auto-columns: 1fr;
        grid-auto-flow: column;
    `};
`;
export const RentVasListItem = styled.li`
    display: grid;
    row-gap: ${getPurpurSpacing('100')};

    ${purpurMedia('lg')`
        grid-template-rows: subgrid;
        grid-row: span 3;
    `};
`;
export const RentVasTitle = styled.h4`
    margin: 0;
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightBold')};
    grid-row: 2;
`;

export const RentVasDescription = styled(HtmlContent)`
    font-size: ${getPurpurTypography('scale75')};
    grid-row: 3;
`;
